import { useEffect, useRef, useState } from "react";
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import CustomGauge from "../EquipmentList/RadialChart";
import "../AuxiliaryEngine/EngineMonitor.css";
import EngineHeader from "../Equip2/EngineHeader";
const gauges = [
  { name: "Power",     value: 959,  unit: "kW", max: 2000 },
  { name: "Amperage",  value: 1388, unit: "A",  max: 2000 },
  { name: "Voltage",   value: 454,  unit: "V",  max: 1000 },
  { name: "Frequency", value: 59.9, unit: "Hz", max: 100  },
];
const DARK_GRID = "rgba(200,210,225,0.6)";
const TICK = "#94a3b8";

const baseOpts = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
    y: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
  },
};
const ALARMS_LEFT = [
  "COMMON SHUTDOWN","EMERGENCY SHUTDOWN","SHUTDOWN FROM SAFETY SYS",
  "L/O LOW PRESS SHUTDOWN","HT CFW OUT HIGH T SHUTDOWN","CONTROL SOURCE FAIL",
  "GOVERNOR SOURCE FAIL","LO FLT DIFF .P.H","FO FLT DIFF .P.H",
  "LO SUMP TK L.I","LO SUMP TK L.H","F/O DRAIN BOX HIGH LEVEL",
  "PRE LO PRESS LOW","NO 1/2 G/E PSU COMMON ABN",
  "NO 1/2 G/E PSU BATT. CHARGER ALM","COMMON ABNORMAL ALARM",
].map(l => ({ label: l, ok: true }));

const SENSORS = [
  ["Engine Running","75","°C"],
  ["Load Demand","28","°C"],
  ["Governor Mode","65","°C"],
  ["Start Mode","31","°C"],
  ["Cooling Water Temp","65","°C"],
  ["Lub. Oil Pressure","1.82","BR"],
  ["Fuel Temperature","3.21",""],
  ["Charge Air Temp","447","°C"],
].map(([label, value, unit]) => ({ label, value, unit }));

const SENSORS1 = [
  ["EXH. GAS MEAN","412","°C"],
  ["T/C RPM PICK UP","3100","RPM"],
  ["ENGINE SPEED","900","RPM"],
].map(([label, value, unit]) => ({ label, value, unit }));

const EXH_TEMP = [605, 613, 613, 612, 619, 624];
const EXH_DEV  = [7, 1, 1, 1, 7, 11];

const BOTTOM_ALARMS = [
  ["BOTH TACHO FAILURE TRIP","SAFETY TRIP CIRCUIT FAILURE","JET SYSTEM FAILURE","GOVERNOR FAIL"],
  ["T/C TACHO FAILURE","MONITORING SYSTEM FAILURE","TACHO FAILURE","OVERSPEED TRIP (1ST)"],
  ["OVERSPEED TRIP (2ND)","START FAILURE","STOP FAILURE","SAFETY SYSTEM FAILURE"],
  ["EXH GAS TEMP HIGH OR LOW","3.W PRE HEATER ON","TACHO B FAILURE",""],
];

export default function AuxiliaryEngine1({activeAE = "" }) {
  const [alarms4]  = useState([]);
  const [alarms5]  = useState([]);
  const [alarms6]  = useState([]);
  const [alarms7]  = useState([]);
  const [alarms8]  = useState([]);
  const [alarms9]  = useState([]);
  const [alarms10] = useState([]);
  const [alarms11] = useState([]);
  const [alarms12] = useState([]);
  const [alarms13] = useState([]);
  const [alarms14] = useState([]);
  const [alarms15] = useState([]);
  const [alarms16] = useState([]);
  const [alarms17] = useState([]);
  const [alarms18] = useState([]);
  const [alarms19] = useState([]);
  const aeItems = [
    { label: "AE1", to: "/auxiliaryEngine1" },
    { label: "AE2", to: "/auxiliaryEngine2" },
    { label: "AE3", to: "/auxiliaryEngine3" },
    { label: "AE4", to: "/auxiliaryEngine4" },
  ];

    const cylRef  = useRef(null);
    const exhRef  = useRef(null);
    const fuelRef = useRef(null);

    
  const Gauge = ({ label, value, unit, color, pct }) => {
  const offset = 110 - pct * 110;
   useEffect(() => {
      const Chart = window.Chart;
      if (!Chart) return;
  
      const cylChart = new Chart(cylRef.current, {
        type: "bar",
        data: {
          labels: ["Cyl.1", "Cyl.2", "Cyl.3", "Cyl.4", "Cyl.5", "Cyl.6"],
          datasets: [{
            label: "Power Output (%)",
            data: [98, 101, 97, 100, 99, 98],
            backgroundColor: "rgba(59,130,246,0.15)",
            borderColor: "#3b82f6",
            borderWidth: 1.5,
            borderRadius: 4,
          }],
        },
        options: {
          ...baseOpts,
          scales: {
            x: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
            y: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 }, callback: (v) => v + "%" }, min: 80, max: 110 },
          },
        },
      });
  
      const exhChart = new Chart(exhRef.current, {
        type: "line",
        data: {
          labels: ["Cyl.1", "Cyl.2", "Cyl.3", "Cyl.4", "Cyl.5", "Cyl.6"],
          datasets: [{
            label: "Exhaust Temp (°C)",
            data: [405, 418, 412, 408, 415, 420],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59,130,246,0.06)",
            borderWidth: 2,
            pointRadius: 4,
            pointBackgroundColor: "#3b82f6",
            fill: true,
            tension: 0.3,
          }],
        },
        options: {
          ...baseOpts,
          scales: {
            x: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } } },
            y: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 }, callback: (v) => v + "°" }, min: 380, max: 440 },
          },
        },
      });
  
      const fuelChart = new Chart(fuelRef.current, {
        type: "line",
        data: {
          labels: ["00:00","02:00","04:00","06:00","08:00","10:00","12:00","14:00","16:00","18:00","20:00","22:00","24:00"],
          datasets: [{
            label: "Fuel Consumption (g/kWh)",
            data: [175, 182, 178, 185, 180, 176, 183, 179, 181, 184, 178, 182, 180],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59,130,246,0.05)",
            borderWidth: 2,
            pointRadius: 2,
            fill: true,
            tension: 0.4,
          }],
        },
        options: {
          ...baseOpts,
          scales: {
            x: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 9 }, maxRotation: 0, autoSkip: true, maxTicksLimit: 6 } },
            y: { grid: { color: DARK_GRID }, ticks: { color: TICK, font: { size: 10 } }, min: 80, max: 240 },
          },
        },
      });
  
      return () => { cylChart.destroy(); exhChart.destroy(); fuelChart.destroy(); };
    }, []);
  return (
    <div style={s.gaugeWrap}>
      <div style={s.gaugeLabel}>{label}</div>
      <svg width="90" height="56" viewBox="0 0 90 56" role="img" aria-label={`${label} ${value} ${unit}`}>
        <path d="M10 50 A35 35 0 0 1 80 50" fill="none" stroke="#e2e8f0" strokeWidth="8" strokeLinecap="round" />
        <path
          d="M10 50 A35 35 0 0 1 80 50"
          fill="none" stroke={color} strokeWidth="8" strokeLinecap="round"
          strokeDasharray="110" strokeDashoffset={offset}
        />
        <text x="45" y="40" textAnchor="middle" fontFamily="'Share Tech Mono',monospace" fontSize="12" fill="#1e293b" fontWeight="700">{value}</text>
        <text x="45" y="52" textAnchor="middle" fontFamily="'Rajdhani',sans-serif" fontSize="9" fill="#94a3b8">{unit}</text>
      </svg>
    </div>
  );
};

  return (
    <React.Fragment>
      <div className="page-content">
         <Container fluid>
     
       
          <Card className="em-card">

      <EngineHeader activePage="Auxiliary Engine" activeAE="AE1" />

            <CardBody className="em-body">
              <Row className="g-2">
<div className="em-nav">
            {aeItems.map(({ label, to }) => (
              <button
                key={label}
                className={`em-nb${activeAE === label ? " em-nb-active" : ""}`}
              >
                <Link to={to}>{label}</Link>
              </button>
            ))}
          </div>
                {/* ── LEFT: alarm list ── */}
                {/* <Col lg={2}>
                  <div className="em-glass em-panel">
                    <div className="em-section-hdr">
                      <span className="em-sec-label">Engine Status</span>
                      
                    </div>
                    <div className="em-gen-btns">
                      {[1,2,3,4].map(n => (
                        <button key={n} className="em-gen-btn">{n}</button>
                      ))}
                    </div>
                    {ALARMS_LEFT.map((item, i) => (
                      <div key={i} className="em-alarm-row">
                        <span>{item.label}</span>
                        <span className="em-dot em-dot-green" />
                      </div>
                    ))}
                  </div>
                </Col> */}

                {/* ── MIDDLE: sensor values ── */}
                <Col lg={2}>
                
                  <div className="em-glass em-panel em-panel-scroll">
                     <div className="em-section-hdr">
                      <span className="em-sec-label">Engine Status</span>
                      
                    </div>
                    {SENSORS.map((item, i) => (
                      <div key={i} className="em-sensor-row">
                        <span className="em-s-label">{item.label}</span>
                        <div className="em-s-val-group">
                          <span className="em-s-val">{item.value}</span>
                          <span className="em-s-unit">{item.unit}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>

                {/* ── RIGHT: gauges + exhaust + engine ── */}
                <Col lg={7}>
                  <div className="em-right-col">
                    <div className="em-glass em-engine-section">
                      <img
                        src="/asset/windingtemp.jpeg"
                        alt="Engine diagram"
                        className="em-engine-img"
                      />
                      <div style={s.visTopbar}>
            {["System Normal","Fuel System Normal","Lubrication Normal","Cooling Normal","Air System Normal","Exhaust Normal"].map((badge, i) => (
              <span key={i} style={s.sysBadge}>{badge}</span>
            ))}
          </div>
                      {/* <div className="em-glass em-exh-wrap">
                      <div className="em-exh-left">
                        {SENSORS1.map((item, i) => (
                          <div key={i} className="em-sensor-row">
                            <span className="em-s-label">{item.label}</span>
                            <div className="em-s-val-group">
                              <span className="em-s-val">{item.value}</span>
                              <span className="em-s-unit">{item.unit}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="em-exh-right">
                        <div className="em-exh-title">EXH. GAS TEMP [°C]</div>
                        <div className="em-exh-title">EXH. GAS DEVIATION</div>
                        <div className="em-exh-grid">
                          {["NO.1","NO.2","NO.3","NO.4","NO.5","NO.6"].map((h,i) => (
                            <div key={i} className="em-exh-head">{h}</div>
                          ))}
                          {[alarms8,alarms9,alarms10,alarms11,alarms12,alarms13].map((arr, i) => (
                            <div key={i} className="em-exh-val">
                              {arr.length ? arr.map((it,j) => <span key={j}>{it.min_value}</span>) : EXH_TEMP[i]}
                            </div>
                          ))}
                          {[alarms14,alarms15,alarms16,alarms17,alarms18,alarms19].map((arr, i) => (
                            <div key={i} className="em-exh-dev">
                              {arr.length ? arr.map((it,j) => <span key={j}>{it.min_value}</span>) : `+${EXH_DEV[i]}`}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div> */}
                    </div>
                    
                    {/* Exhaust */}
                    

                  
                  </div>
                </Col>
                <Col lg={3} className="mt-2">
                  <div style={s.panel}>
          <div style={s.panelTitle}>Real Time Gauges</div>
          <div style={s.gaugeGrid}>
            <Gauge label="Engine Load"   value="72%"  unit=""     color="#2563eb" pct={0.72} />
            <Gauge label="Fuel Rate"     value="310"  unit="L/hr" color="#d97706" pct={0.50} />
            <Gauge label="Oil Pressure"  value="4.6"  unit="bar"  color="#16a34a" pct={0.41} />
            <Gauge label="Coolant Temp." value="75"   unit="°C"   color="#0891b2" pct={0.59} />
            <Gauge label="Exhaust Temp." value="412"  unit="°C"   color="#dc2626" pct={0.80} />
            <Gauge label="Intake Air"    value="0.9"  unit="bar"  color="#7c3aed" pct={0.20} />
          </div>
        </div>
        </Col>
              </Row>
  <div style={s.bottomGrid}>
        <div style={s.panel}>
          <div style={s.panelTitle}>Cylinder Performance</div>
          <div style={{ height: 140, position: "relative" }}>
            <canvas ref={cylRef} role="img" aria-label="Cylinder power output bar chart" />
          </div>
          <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6 }}>
            Avg. Power Balance: <span style={{ color: "#16a34a", fontWeight: 700 }}>98.8%</span>
          </div>
        </div>

        <div style={s.panel}>
          <div style={s.panelTitle}>Exhaust Gas Temp (°C)</div>
          <div style={{ height: 140, position: "relative" }}>
            <canvas ref={exhRef} role="img" aria-label="Exhaust gas temperature line chart" />
          </div>
          <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6 }}>
            Mean: <span style={{ color: "#d97706", fontWeight: 700 }}>413 °C</span>
          </div>
        </div>

        <div style={s.panel}>
          <div style={s.panelTitle}>Fuel Consumption Trend</div>
          <div style={{ height: 140, position: "relative" }}>
            <canvas ref={fuelRef} role="img" aria-label="Fuel consumption trend line chart" />
          </div>
          <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 6 }}>
            Avg 24h: <span style={{ color: "#2563eb", fontWeight: 700 }}>180 g/kWh</span>
          </div>
        </div>
      </div>

      {/* ── ENVIRONMENT + ALARMS ── */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 10 }}>

        <div style={s.panel}>
          <div style={s.panelTitle}>Environment</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8 }}>
            {[
              { icon: "🌊", label: "Sea Temp.",        value: "26.4 °C" },
              { icon: "🌡",  label: "Ambient Temp.",   value: "24.8 °C" },
              { icon: "💧", label: "Humidity",          value: "78 %" },
              { icon: "🧭", label: "Barometric Press.", value: "1013 mbar" },
            ].map(({ icon, label, value }, i) => (
              <div key={i} style={s.envItem}>
                <span style={{ fontSize: 20 }}>{icon}</span>
                <div>
                  <div style={{ fontSize: 9, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em" }}>{label}</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#1e293b" }}>{value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={s.panel}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div style={{ ...s.panelTitle, marginBottom: 0, paddingBottom: 0, borderBottom: "none" }}>Alarms &amp; Warnings</div>
            <span style={{ fontSize: 11, color: "#2563eb", cursor: "pointer", fontWeight: 700 }}>View All →</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8 }}>
            {[
              { count: "0",  label: "Critical", color: "#dc2626", bg: "#fef2f2" },
              { count: "2",  label: "Major",    color: "#d97706", bg: "#fffbeb" },
              { count: "2",  label: "Minor",    color: "#ca8a04", bg: "#fefce8" },
              { count: "12", label: "Info",     color: "#2563eb", bg: "#eff6ff" },
            ].map(({ count, label, color, bg }, i) => (
              <div key={i} style={{ ...s.alarmItem, background: bg, border: `1px solid ${color}30` }}>
                <div style={{ fontSize: 28, fontWeight: 700, color, lineHeight: 1 }}>{count}</div>
                <div style={{ fontSize: 10, color: "#64748b", marginTop: 4, textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 600 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
           
            </CardBody>

          </Card>
    
      </Container>
      </div>
    </React.Fragment>
  );
}

const s = {
  root: {
    background: "#f8fafc",
    color: "#1e293b",
    fontFamily: "'Rajdhani', sans-serif",
    fontSize: 14,
    padding: 12,
    minHeight: "100vh",
  },
  kpiGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: 8,
    marginBottom: 10,
  },
  kpiCard: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: "10px 14px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  kpiLabel:   { fontSize: 10, color: "#94a3b8", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 600 },
  kpiValue:   { fontSize: 24, fontWeight: 700, lineHeight: 1, margin: "2px 0" },
  kpiUnit:    { fontSize: 12, color: "#94a3b8" },
  kpiBar:     { height: 4, background: "#e2e8f0", borderRadius: 2, marginTop: 6, overflow: "hidden" },
  kpiBarFill: { height: "100%", borderRadius: 2 },

  midGrid: { display: "grid", gridTemplateColumns: "220px 1fr 280px", gap: 10, marginBottom: 10 },

  panel: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: 12,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  },
  panelTitle: {
    fontSize: 10,
    color: "#64748b",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    fontWeight: 700,
    marginBottom: 10,
    paddingBottom: 6,
    borderBottom: "1px solid #f1f5f9",
  },

  statusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 0",
    borderBottom: "1px solid #f1f5f9",
    fontSize: 13,
  },
  sLabel: { color: "#64748b" },
  sVal:   { color: "#1e293b", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 },
  sDot:   { width: 7, height: 7, borderRadius: "50%", background: "#16a34a", display: "inline-block" },

  engineVis: {
    background: "#f0f7ff",
    border: "1px solid #bfdbfe",
    borderRadius: 8,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  visTopbar: {
    display: "flex",
    gap: 6,
    padding: "8px 12px",
    background: "#eff6ff",
    borderBottom: "1px solid #bfdbfe",
    flexWrap: "wrap",
  },
  sysBadge: {
    fontSize: 10,
    padding: "3px 10px",
    borderRadius: 4,
    background: "#dcfce7",
    border: "1px solid #86efac",
    color: "#15803d",
    fontWeight: 700,
  },
  engineCanvas: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    minHeight: 220,
  },

  gaugeGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 },
  gaugeWrap: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: 10,
    textAlign: "center",
  },
  gaugeLabel: { fontSize: 9, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 6, fontWeight: 600 },

  bottomGrid: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 },

  envItem: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: 10,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  alarmItem: {
    borderRadius: 8,
    padding: 10,
    textAlign: "center",
  },
};